// src/components/admin/CouponForm.jsx
import React, { useState, useEffect } from 'react';
import { Drawer, DrawerTrigger, DrawerContent } from "../ui/drawer";
const API = process.env.REACT_APP_API_BASE;

export default function CouponForm({ editCoupon, onReload, onClose }) {
  const [form, setForm] = useState({
    name: '',
    discountType: 'percent',
    discountValue: '',
    duration: 'once',
    durationInMonths: '',
    country: '',
    endDate: '', // for coupon UI purpose
    promotionCode: '',
    promotionMaxRedemptions: '',
    promotionExpiresAt: '', 
  });
  

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/countries`)
      .then(res => res.json())
      .then(setCountries);
  }, []);

  useEffect(() => {
    if (editCoupon) {
      setForm({
        name: editCoupon.name,
        discountType: editCoupon.discountType,
        discountValue: editCoupon.discountValue,
        duration: editCoupon.duration,
        durationInMonths: editCoupon.durationInMonths || '',
        country: editCoupon.country,
        endDate: editCoupon.endDate ? new Date(editCoupon.endDate).toISOString().split('T')[0] : '',
        promotionCode: editCoupon.promotionCode || '',
        promotionMaxRedemptions: editCoupon.promotionMaxRedemptions || '',
        promotionExpiresAt: editCoupon.promotionExpiresAt ? new Date(editCoupon.promotionExpiresAt).toISOString().split('T')[0] : '',
      });
    }
  }, [editCoupon]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = editCoupon ? 'PUT' : 'POST';
    const url = editCoupon ? `${API}/api/coupons/${editCoupon._id}` : `${API}/api/coupons`;

    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    if (res.ok) {
      onReload();
      onClose();
    }
  };

  return (
    <form className="p-6 space-y-4" onSubmit={handleSubmit}>
      <div>
        <label className="block mb-1 font-medium">Country</label>
        <select name="country" value={form.country} onChange={handleChange} className="w-full p-2 border rounded" required>
          <option value="">Select Country</option>
          {countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium">Coupon Name</label>
        <input name="name" placeholder="Enter internal coupon name" value={form.name} onChange={handleChange} className="w-full p-2 border rounded" required/>
      </div>

      <div>
        <label className="block mb-1 font-medium">Discount Type</label>
        <select name="discountType" value={form.discountType} onChange={handleChange} className="w-full p-2 border rounded" required>
          <option value="percent">Percentage (%)</option>
          <option value="amount">Fixed Amount</option>
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium">Discount Value</label>
        <input name="discountValue" placeholder="Enter discount value" value={form.discountValue} onChange={handleChange} type="number" className="w-full p-2 border rounded" required/>
      </div>

      <div>
        <label className="block mb-1 font-medium">Duration</label>
        <select name="duration" value={form.duration} onChange={handleChange} className="w-full p-2 border rounded" required>
          <option value="once">Once</option>
          <option value="repeating">Repeating</option>
          <option value="forever">Forever</option>
        </select>
      </div>

      {form.duration === 'repeating' && (
        <div>
          <label className="block mb-1 font-medium">Duration in Months</label>
          <input name="durationInMonths" placeholder="Number of months" value={form.durationInMonths} onChange={handleChange} type="number" className="w-full p-2 border rounded" required/>
        </div>
      )}

      <div>
        <label className="block mb-1 font-medium">Coupon End Date (Optional)</label>
        <input
          name="endDate"
          type="date"
          value={form.endDate}
          onChange={handleChange}
          className="w-full p-2 border rounded"
        />
      </div>

      {/* Promotion fields */}
      <div>
        <label className="block mb-1 font-medium">Promotion Code (User Enters This)</label>
        <input name="promotionCode" placeholder="e.g., SAVE25" value={form.promotionCode} onChange={handleChange} className="w-full p-2 border rounded" required/>
      </div>

      <div>
        <label className="block mb-1 font-medium">Max Redemptions (Optional)</label>
        <input name="promotionMaxRedemptions" placeholder="e.g., 100" value={form.promotionMaxRedemptions} onChange={handleChange} type="number" className="w-full p-2 border rounded" />
      </div>

      <div>
        <label className="block mb-1 font-medium">Promotion Expiry Date (Optional)</label>
        <input
          name="promotionExpiresAt"
          type="date"
          value={form.promotionExpiresAt}
          onChange={handleChange}
          className="w-full p-2 border rounded"
        />
      </div>

      <div className="text-center pt-4">
        <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded">Save Coupon</button>
      </div>
    </form>
  );
}